import { useInjector } from '~/common/useInjector';
import { AppStates as AppStatesReact } from './useNavigation.consts';
import { isReactFirst } from '~/utils/environment.utils';

export default function useAppStates() {
    const { AppStates } = useInjector(['AppStates']);
    if (isReactFirst()) {
        return AppStatesReact;
    }
    return AppStates || AppStatesReact;
}
